import { render, staticRenderFns } from "./RouterTransition.vue?vue&type=template&id=50132558&scoped=true"
import script from "./RouterTransition.vue?vue&type=script&lang=js"
export * from "./RouterTransition.vue?vue&type=script&lang=js"
import style0 from "./RouterTransition.vue?vue&type=style&index=0&id=50132558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50132558",
  null
  
)

export default component.exports